import './polyfill'
import './filters'
import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import routes from './routes'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store/store'
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import {getAcls, validarPermiso} from './plugins/acl'
import Chartkick from 'vue-chartkick'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import './helpers'
import Chart from 'chart.js';
import AlertsPlugin from './plugins/alerts';
import ColorBadgePlugin from './plugins/colorBadge';
Vue.use(vueNumeralFilterInstaller);
Vue.use(Chartkick.use(Chart));
//Vue.use(require('vue-moment'));
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(require('vue-moment'));
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
window.axios = require('axios')
Vue.use(VueFormWizard);
Vue.use(VueLodash);
Vue.use(lodash);
Vue.use(AlertsPlugin);
Vue.use(ColorBadgePlugin);

const filter = function (text, length = 120) {
    return text.length > length ? text.slice(0, length) + '...' : text;
};




/**
 * Filtro para truncar texto
 */
Vue.filter('truncate', filter);

const router = new VueRouter({
    routes,
    linkActiveClass: 'active'
})

import VeeValidate, {Validator} from 'vee-validate'
import es from 'vee-validate/dist/locale/es'

Vue.use(VeeValidate, {
    fieldsBagName: 'vvFields',
    events: 'change'
});

Validator.localize('es', es);

router.beforeEach((to, from, next) => {


    let usuario = localStorage.getItem('token')
    let cambioContra = localStorage.getItem('cambio_clave')
    let autorizado = to.matched.some(record => record.meta.autenticado); // verifica en los meta de la ruta si debe estar autenticado para acceder o no

    if (autorizado) {
        if (!usuario) {
            next('/login')
        } else {

            if (cambioContra == 'true' && to.path != '/cambiar-contrasena') {
                next('/cambiar-contrasena')
            }

            let acl = getAcls()
            let permisoRuta = []
            permisoRuta = to.meta.permiso
            let permisos = acl.permisos
            acl.roles.map((rol) => permisos.push(rol));
            let valida = validarPermiso(permisos, permisoRuta)
            if (valida) {
                store.commit('permiso', permisos)
                next()
            } else if (to.path !== '/login') {
                next('inicio')
            }
        }
    } else {

        // Ver detalles del producto con QR.
        try {
            if (
                (to.name != "visualizer-product-qr" && to.matched.some(record => record.meta.isVisualizerProduct)) ||
                (to.name != "short-urls-interceptor" && to.matched.some((record) => record.meta.isInterceptorShortUrls))
            ) next(to.fullPath)
        } catch (e) {
            next()
        }

        next()
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    routes,
    template: '<App/>',
    components: {
        App
    }
})

export default router;
